export enum MeatHandlerStatus {
  Pending = 100, // Yellow
  Active = 200, // Green
  Suspended = 300, // Red
  Blacklisted = 400, // Dark-Red
  Barred = 500,// Black
  Expired = 600,//Orange
  ALL = 1
}